/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfOperationalPhoneTypeDto } from "../models/AjaxResponseOfListOfOperationalPhoneTypeDto";
import type { AjaxResponseOfOperationalPhoneTypeDto } from "../models/AjaxResponseOfOperationalPhoneTypeDto";
import type { CreateOrUpdateOperationalPhoneTypeDto } from "../models/CreateOrUpdateOperationalPhoneTypeDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalPhoneTypesAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfOperationalPhoneTypeDto Success
   * @throws ApiError
   */
  public getAll(): CancelablePromise<AjaxResponseOfListOfOperationalPhoneTypeDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/phone-types",
    });
  }
  /**
   * @returns AjaxResponseOfOperationalPhoneTypeDto Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateOperationalPhoneTypeDto;
  }): CancelablePromise<AjaxResponseOfOperationalPhoneTypeDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/phone-types",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    phoneTypeId,
  }: {
    phoneTypeId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/phone-types/{phoneTypeId}",
      path: {
        phoneTypeId: phoneTypeId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalPhoneTypeDto Success
   * @throws ApiError
   */
  public update({
    phoneTypeId,
    requestBody,
  }: {
    phoneTypeId: number;
    requestBody?: CreateOrUpdateOperationalPhoneTypeDto;
  }): CancelablePromise<AjaxResponseOfOperationalPhoneTypeDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/phone-types/{phoneTypeId}",
      path: {
        phoneTypeId: phoneTypeId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
